document.addEventListener("alpine:init", () => {
  Alpine.data("VariantDropDown", () => ({
    expanded: false,
    locked: false,
    toggle() {
      if (this.expanded) {
        this.close();
        return;
      }
      this.$refs.button.focus();
      this.expanded = true;
      this.$refs.panel.style.display = "";
    },
    close(focusAfter) {
      if (!this.expanded) return;
      this.expanded = false;
      this.$refs.panel.style.display = "none";
      if (focusAfter) {
        this.$focus.focus(focusAfter);
      }
    },
    lockOptionChangeHandler() {
      this.locked = true;
    },
    unlockOptionChangeHandler($el) {
      this.locked = false;
      if ($el) this.__handleOptionChange($el);
    },
    __handleOptionChange($el) {
      const position = parseInt($el.dataset.position, 10);
      const value = $el.value.trim();
      this.$dispatch("variant-change", { position, value });
    },
    selectOption($el) {
      const input = $el.previousElementSibling;

      if (input) {
        // Find the section element (5 levels up)
        let productSection = this.$root;
        for (let i = 0; i < 5; i++) {
          if (productSection.parentElement) {
            productSection = productSection.parentElement;
          }
        }

        if (productSection) {
          const position = parseInt(input.dataset.position, 10);
          const value = input.value.trim();

          // Get the Alpine component instance and update the option
          const productComponent = Alpine.$data(productSection);
          if (productComponent) {
            productComponent[`option${position}`] = value;
            input.checked = true;
          }
        }

        this.close();
      }
    },
    optionChange($el) {
      // Get the parent Theme_Product component
      const productComponent = Alpine.closestRoot($el).$data;

      // Call the Theme_Product's __handleOptionChange method
      productComponent.__handleOptionChange($el);

      this.close();
    },
  }));
});
